module.exports = __webpack_public_path__ + "img/money-pound-box-fill.61259ca1.svg";